import {common_utils} from "../common/common_utils";
import {game_3011_12_13} from "./game_3011_12_13";

function game_3013()
{

}
game_3013.BetsNum = 12;
game_3013.BetsOdd = [45, 38, 27, 22, 16, 13, 12, 10, 6, 7, 5, 4];
game_3013.BetsBgColor = [0, 1, 2, 0, 1, 2, 0, 1, 2, 0, 1, 2];
game_3013.BetsAnimal = [2, 2, 2, 3, 3, 3, 1, 1, 1, 0, 0, 0,];

game_3013.ItemNum = 23;
game_3013.GameItemBgColorPos = [0,1, 2, 0, 1, 2, 0, 1, 2,0, 1, 2,0, 1, 2,0, 1, 2,0, 1, 2,0, 1, 2];
game_3013.GameItemAnimalPos = [1, 1, 1, 0, 0, 0, 2, 2, 2, 3, 3, 3, 1, 1, 1, 0, 0, 0, 2, 2, 2, 3, 3, 3,];

game_3013.getAnimalIconIndex= function(index)
{
    if(index === 0)
    {
      return "logo_4";
    }
    else if(index === 1)
    {
      return "logo_3";
    }
    else if(index === 2)
    {
      return "logo_1";
    }
    else if(index === 3)
    {
      return "logo_2";
    }
}

game_3013.getColorBgName = function(colorIndex)
{
  if(colorIndex === 0)
  {
    return "icon_red";
  }
  else if(colorIndex === 1)
  {
    return "icon_green";
  }
  else if(colorIndex === 2)
  {
    return "icon_yellow";
  }
  return "icon_red";
};

game_3013.getBetsPos=function(pos)
{
    let betPos = pos-1;
    if(betPos>=0 && betPos < this.BetsNum)
    {
        return betPos;
    }
    console.log(betPos)
    return 0;
}

  game_3013.getColorCircleBg= function(pos)
  {
    let betPos = this.getBetsPos(pos);
    let animal = this.BetsBgColor[betPos];
    return this.getColorBgName(animal);

  }

game_3013.getAnimalIcon =  function(pos)
{
    let betPos = this.getBetsPos(pos);
    let animal = this.BetsAnimal[betPos];
    return this.getAnimalIconIndex(animal);
}


game_3013.getMultiple =  function(pos)
{
    let betPos = this.getBetsPos(pos);
    return this.BetsOdd[betPos];
}

game_3013.getBetsList =  function (betsInfo)
{
  let betsData = [];
  for(let i = 0; i < this.BetsNum; i++)
  {
      let betInfo = new Object();
      let betPos = i+1;
      betInfo.animal =  this.getAnimalIcon(betPos);
      betInfo.bgName = this.getColorCircleBg(betPos);
      betInfo.multiple = this.getMultiple(betPos);
      betInfo.betAmount = 0;
      betInfo.winAmount = 0;
      betsData[i] = betInfo;
      // betsData.push(betInfo);
  }
  for (const [key, value] of Object.entries(betsInfo))
  {
    let index = this.getBetsPos(value.betPos);
    let betInfo = betsData[index];
    betInfo.betPos = value.betPos;
    if(value.betAmount)
    {
      betInfo.betAmount = value.betAmount;
    }
    if(value.winAmount)
    {
      betInfo.winAmount = value.winAmount;
    }

    betsData[index] = betInfo;
  }
  return betsData;
}

game_3013.getItemPos=function(pos)
{
    let betPos = pos;
    if(betPos>0 && betPos < this.ItemNum)
    {
      return betPos;
    }
    return 0;
}

game_3013.getItemColorBg= function(pos)
{
  let itemPos = this.getItemPos(pos);
  let animal = this.GameItemBgColorPos[itemPos];
  return this.getColorBgName(animal);
}


game_3013.getItemAnimalBg= function(pos)
{
    let itemPos = this.getItemPos(pos);
    let animal = this.GameItemAnimalPos[itemPos];
    return this.getAnimalIconIndex(animal);
}

export {
  game_3013
};



// WEBPACK FOOTER //
// ./src/components/esports/game_3013.js